export default "__VITE_PUBLIC_ASSET__b50bd340__"